<template>
  <div>
    <div
      v-show="showBtn"
      class="special-coupon-btn-wrap"
      :class="{
        'custom-transition': isTouchEnd,
      }"
      :style="{
        left: `${btnPoint.x}px`,
        top: `${btnPoint.y}px`,
        transform: `translate(${transform.x}px, ${transform.y}px)`,
      }"
      @touchstart="touchStart"
      @touchmove="touchMove"
      @touchend="touchEnd"
      @click="toSpecialCouponPage"
    >
      <img
        src="@/assets/img/chargingVoucher/special-coupon-img.png"
        class="special-coupon-btn"
      >
    </div>
  </div>
</template>

<script>
import { querySpecialRote } from '@/common/api.js';

class Point {
  x = 0;
  y = 0;
}

export default {
  name: 'SpecialCouponBtn',
  props: {
    agencyCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 按钮位置
      btnPoint: new Point(),
      // 暂存位置
      tempPoint: new Point(),
      // 相对偏移
      transform: new Point(),
      // 是否触摸结束
      isTouchEnd: false,
      // 特惠券包类型
      roteType: 'noRote' // 浮框接口 noRote ：无接口/dcjc ：虾米车服/others ：其他代理商
    };
  },
  computed: {
    showBtn() {
      return this.$parent?.curProviderTab?.key === 'XIAOJU' && this.roteType !== 'noRote';
    }
  },
  created() {
    const btnPoint = JSON.parse(localStorage.getItem('_btnPoint'));
    if (btnPoint) {
      this.btnPoint = btnPoint;
    } else {
      const clientWidth = document.documentElement.clientWidth;
      this.btnPoint.x = clientWidth * 0.80;
      const clientHeight = document.documentElement.clientHeight;
      this.btnPoint.y = clientHeight * 0.30;
      console.log(this.btnPoint);
    }

    this.toQuerySpecialRote();
  },
  methods: {
    // 触摸开始
    touchStart(e) {
      console.log('touchStart');
      const { touches } = e;
      if (touches && touches.length > 0) {
        this.tempPoint = {
          ...this.btnPoint
        };
        this.btnPoint = {
          x: touches[0].pageX,
          y: touches[0].pageY
        };
        this.transform = {
          x: this.tempPoint.x - this.btnPoint.x,
          y: this.tempPoint.y - this.btnPoint.y
        };
      }
    },
    // 拖动
    touchMove(e) {
      console.log('touchMove');
      e.preventDefault();
      const { touches } = e;
      if (touches && touches.length > 0) {
        const pageY = touches[0].pageY;
        this.btnPoint.y = pageY;

        const pageX = touches[0].pageX;
        this.btnPoint.x = pageX;
      }
    },
    // 触摸结束
    touchEnd(e) {
      console.log('touchEnd');

      this.btnPoint = {
        x: this.btnPoint.x + this.transform.x,
        y: this.btnPoint.y + this.transform.y
      };

      this.tempPoint = new Point();
      this.transform = new Point();

      setTimeout(() => {
        this.isTouchEnd = true;
        setTimeout(() => {
          this.isTouchEnd = false;
        }, 250);

        const clientWidth = document.documentElement.clientWidth;
        if (this.btnPoint.x < clientWidth * 0.4) {
          this.btnPoint.x = -5;
        } else {
          this.btnPoint.x = clientWidth * 0.80;
        }

        const clientHeight = document.documentElement.clientHeight;
        if (this.btnPoint.y < 0) {
          this.btnPoint.y = 0;
        } else if (this.btnPoint.y > clientHeight * 0.749) {
          this.btnPoint.y = clientHeight * 0.749;
        }

        localStorage.setItem('_btnPoint', JSON.stringify(this.btnPoint));
      }, 50);
    },
    toSpecialCouponPage(e) {
      console.log('click');
      e.preventDefault();

      localStorage.setItem('_chargePhone', this.$parent.form.chargePhone);
      if (this.$browserEnv == 0) {
        const roteTypeDict = {
          dcjc: 'chargingVoucher',
          others: 'chargingVoucherAgency'
        };
        const origin = document.location.origin;
        const pageName = roteTypeDict[this.roteType] || '';
        const url = `${origin}/h5/#/${pageName}/specialCoupon?source=wxapp&timestamp=${new Date().getTime()}`;
        const targetUrl = '/pages/chargingVoucher/index';
        wx.miniProgram.navigateTo({
          url: `${targetUrl}?chargingVoucherUrl=${encodeURIComponent(url)}`
        });
      } else {
        const roteTypeDict = {
          dcjc: 'ChargingVoucherSpecialCoupon',
          others: 'ChargingVoucherAgencySpecialCoupon'
        };
        const pageName = roteTypeDict[this.roteType] || '';
        if (pageName) {
          this.$router.push({
            name: pageName
          });
        } else {
          this.$toast('购买渠道错误');
        }
      }
    },
    // 查询特惠包购买渠道
    toQuerySpecialRote() {
      const param = {
        agencyCode: this.agencyCode || ''
      };
      querySpecialRote(param).then((res) => {
        if (res) {
          this.roteType = res.roteType;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.special-coupon-btn-wrap {
  position: fixed;
  z-index: 99;
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.custom-transition {
    transition-property: left, right, top, bottom;
    transition-duration: 0.2s;
  }
  .special-coupon-btn {
    overflow: hidden;
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation-duration: 1s;
    animation-name: btn-scale;
    animation-iteration-count: infinite;
    animation-timing-function: ease-out;
    white-space: nowrap;
    font-size: 56px;
    object-fit: contain;
  }
}
@keyframes btn-scale {
  from {
    scale: 0.9;
  }
  50% {
    scale: 1;
  }
  to {
    scale: 0.9;
  }
}
</style>
